import { render } from "./timeline.vue?vue&type=template&id=062bfce8&scoped=true"
import script from "./timeline.vue?vue&type=script&lang=js"
export * from "./timeline.vue?vue&type=script&lang=js"

import "./timeline.vue?vue&type=style&index=0&id=062bfce8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-062bfce8"

export default script